import { useTranslation } from "react-i18next";
import { Badge } from "@/shared/components/ui/badge";
import type { AcceptanceRow } from "./acceptance-rows";

interface AcceptanceSourceBadgeProps {
  readonly kind: AcceptanceRow["kind"];
}

/**
 * Where an acceptance came from. Offline (a paper recorded by an admin) uses
 * the amber variant so it never reads like the routine in-app acceptance.
 */
export function AcceptanceSourceBadge({ kind }: AcceptanceSourceBadgeProps) {
  const { t } = useTranslation();
  return kind === "offline" ? (
    <Badge variant="warning" data-testid="acceptance-source-offline">
      {t("users.tos.source.offline")}
    </Badge>
  ) : (
    <Badge variant="secondary" data-testid="acceptance-source-in-app">
      {t("users.tos.source.inApp")}
    </Badge>
  );
}
